import {take, select} from "redux-saga/effects";
import {put} from "../../../../shared/SagaService";
import {Type} from "../../helper";
import {PageType} from "../../../../enums/PageType";
import actions from "../../actions";
import { SubscriptionCheck } from "bukku/components/Access/helper/subscription/SubscriptionCheck";
import { SubscriptionScopeKey } from "bukku/components/Access/helper/subscription/enum/SubscriptionScopeKey";

function* waitForSuccessAction(transactionType) {
    let loop = true;
    while (loop) {
        const successAction = yield take(actions.TRANSACTION_READ_OUTSTANDING_SUCCESS);
        if (successAction.transactionType === transactionType)
            loop = false;
    }
}

export function* readOutstanding(transactionInitCase, transactionType, originTransaction = {}) {
    const companyCurrencyCode = yield select(state => state.Auth.companyCurrencyCode);

    const hasMultiCurrencySub =
        SubscriptionCheck.withKeys(SubscriptionScopeKey.MULTI_CURRENCY).hasSubscriptionTo();

    switch (transactionType) {
        // Normal
        case Type.sale_credit_note:
        case Type.purchase_credit_note:
        case Type.sale_payment:
        case Type.purchase_payment:
        case Type.sale_refund:
        case Type.purchase_refund: {
            if (originTransaction.contact_id && originTransaction.currency_code) {
                const request = {
                    contact_id: originTransaction.contact_id,
                    // users can't knock off foreign currency txn (eg invoice) if they don't have mutli currency sub
                    currency_code:
                        hasMultiCurrencySub ? originTransaction.currency_code : companyCurrencyCode,
                };

                if (transactionInitCase === PageType.view)
                    request.transaction_id = originTransaction.id;

                yield put(
                    actions.transactionReadOutstanding(transactionType, request),
                );

                yield waitForSuccessAction(transactionType);
            }
            break;
        }
        // Contra
        case Type.contra: {
            if (originTransaction.contact_id && originTransaction.currency_code) {
                const request = {
                    contact_id: originTransaction.contact_id,
                    currency_code: hasMultiCurrencySub ?
                        originTransaction.currency_code : companyCurrencyCode,
                };
                if (transactionInitCase === PageType.view)
                    request.transaction_id = originTransaction.id;

                yield put(
                    actions.transactionReadOutstanding(
                        Type.sale_payment,
                        request,
                        true,
                    ),
                );
                yield waitForSuccessAction(Type.sale_payment);
            }

            if (originTransaction.contact2_id && originTransaction.currency_code) {
                const request = {
                    contact_id: originTransaction.contact2_id,
                    currency_code: hasMultiCurrencySub ?
                        originTransaction.currency_code : companyCurrencyCode,
                };
                if (transactionInitCase === PageType.view)
                    request.transaction_id = originTransaction.id;

                yield put(
                    actions.transactionReadOutstanding(
                        Type.purchase_payment,
                        request,
                        true,
                    ),
                );
                yield waitForSuccessAction(Type.purchase_payment);
            }

            break;
        }
        default:
            break;
    }
}
